import { render, staticRenderFns } from "./CardTicketView.vue?vue&type=template&id=1e6f0cf2"
import script from "./CardTicketView.vue?vue&type=script&lang=js"
export * from "./CardTicketView.vue?vue&type=script&lang=js"
import style0 from "./CardTicketView.vue?vue&type=style&index=0&id=1e6f0cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports